import { AgencyAgentModelLicenceType, LicenceDetailsState } from '@urbanx/agx.agencies.client';

export const LicenceTypeOptions = [
  {
    state: undefined,
    option: {
      value: AgencyAgentModelLicenceType.None,
      label: 'None',
    },
  },
  {
    state: LicenceDetailsState.NSW,
    option: {
      value: AgencyAgentModelLicenceType.Class1,
      label: 'Class 1 Licence',
    },
  },
  {
    state: LicenceDetailsState.NSW,
    option: {
      value: AgencyAgentModelLicenceType.Class2,
      label: 'Class 2 Licence',
    },
  },
  {
    state: LicenceDetailsState.QLD,
    option: {
      value: AgencyAgentModelLicenceType.RealEstateCertificate,
      label: 'Real Estate Certificate',
    },
  },
  {
    state: LicenceDetailsState.QLD,
    option: {
      value: AgencyAgentModelLicenceType.RealEstateLicence,
      label: 'Real Estate Licence',
    },
  },
];
